import PropTypes from 'prop-types';

import latlng from './latlng';

export default PropTypes.arrayOf(latlng);


//////////////////
// WEBPACK FOOTER
// ../~/react-leaflet/es/propTypes/latlngList.js
// module id = 167
// module chunks = 0